/**
 * თარიღებისა და რიცხვების ფორმატირება.
 *
 * `Intl`-ს `ka-GE`-ზე არ ვენდობით: ზოგიერთ გარემოში (მინიმალური ICU)
 * ინგლისურ თვეებზე გადადის. ამიტომ თვეების სახელები ხელითაა.
 */

const MONTHS = [
  'იანვარი',
  'თებერვალი',
  'მარტი',
  'აპრილი',
  'მაისი',
  'ივნისი',
  'ივლისი',
  'აგვისტო',
  'სექტემბერი',
  'ოქტომბერი',
  'ნოემბერი',
  'დეკემბერი',
];

const MONTHS_SHORT = [
  'იან',
  'თებ',
  'მარ',
  'აპრ',
  'მაი',
  'ივნ',
  'ივლ',
  'აგვ',
  'სექ',
  'ოქტ',
  'ნოე',
  'დეკ',
];

const WEEKDAYS_SHORT = ['კვი', 'ორშ', 'სამ', 'ოთხ', 'ხუთ', 'პარ', 'შაბ'];

function toDate(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

const pad = (n: number) => String(n).padStart(2, '0');

/** 18 აგვ 2026 */
export function formatDate(value: string | Date | null | undefined, fallback = '—'): string {
  const d = toDate(value);
  if (!d) return fallback;
  return `${d.getDate()} ${MONTHS_SHORT[d.getMonth()]} ${d.getFullYear()}`;
}

/** 18 აგვისტო 2026 */
export function formatDateLong(value: string | Date | null | undefined, fallback = '—'): string {
  const d = toDate(value);
  if (!d) return fallback;
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

/** 18 აგვ 2026, 21:27 */
export function formatDateTime(value: string | Date | null | undefined, fallback = '—'): string {
  const d = toDate(value);
  if (!d) return fallback;
  return `${formatDate(d)}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** ორშ, 18 აგვ */
export function formatDayShort(value: string | Date | null | undefined, fallback = '—'): string {
  const d = toDate(value);
  if (!d) return fallback;
  return `${WEEKDAYS_SHORT[d.getDay()]}, ${d.getDate()} ${MONTHS_SHORT[d.getMonth()]}`;
}

/** 2026-08-18 — API-სთვის */
export function toIsoDate(value: string | Date): string {
  const d = toDate(value);
  if (!d) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** 85.4% · null → „—" */
export function formatPercent(
  value: number | null | undefined,
  digits = 1,
  fallback = '—',
): string {
  if (value === null || value === undefined || Number.isNaN(value)) return fallback;
  return `${value.toFixed(digits)}%`;
}
